import defaultOgImageJpg from '../../assets/og-image.jpg';
import { canonical, description, join, meta, openGraph, title } from '@rea-argonaut/actions';
import { isNotNullOrUndefinedValue } from '../../helpers/isNotNullOrUndefinedValue';

type Helmet = {
  canonical: string;
  helmetTitle: string;
  description: string;
  siteName: string;
  robots: string | null;
};

export const getHead = (helmet: Helmet) => {
  return join(
    ...[
      title(helmet.helmetTitle),
      description(helmet.description),
      canonical(helmet.canonical),
      openGraph({
        property: 'og:site_name',
        content: helmet.siteName,
      }),
      openGraph({
        property: 'og:image',
        content: defaultOgImageJpg,
      }),
      ...[
        helmet.robots
          ? meta({
              name: 'robots',
              content: helmet.robots,
            })
          : undefined,
      ],
    ].filter(isNotNullOrUndefinedValue),
  );
};
